import React, { useCallback, useMemo } from 'react'
import CustomHeaderNavigation from './CustomHeaderNavigation'
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker'
import { DateSelection } from './types'
import styles from './datePickerWtn.module.scss'
import MonthPicker from './MonthPicker'

interface Props extends ReactDatePickerCustomHeaderProps {
  minDate: DateSelection
  maxDate: DateSelection
}

const DatePickerHeader = ({
  minDate,
  maxDate,
  monthDate,
  changeMonth,
  changeYear,
  decreaseMonth,
  increaseMonth,
  decreaseYear,
  increaseYear,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
  prevYearButtonDisabled,
  nextYearButtonDisabled,
}: Props) => {
  const customheaderConfig = useMemo(
    () => ({
      prev: { disabled: prevMonthButtonDisabled, onClick: decreaseMonth },
      next: { disabled: nextMonthButtonDisabled, onClick: increaseMonth },
      fastPrev: { disabled: prevYearButtonDisabled, onClick: decreaseYear },
      fastNext: { disabled: nextYearButtonDisabled, onClick: increaseYear },
    }),
    [
      decreaseMonth,
      increaseMonth,
      decreaseYear,
      increaseYear,
      prevMonthButtonDisabled,
      nextMonthButtonDisabled,
      prevYearButtonDisabled,
      nextYearButtonDisabled,
    ]
  )

  const handleChange = useCallback(
    date => {
      changeMonth(date?.getMonth())
      changeYear(date?.getFullYear())
    },
    [changeMonth, changeYear]
  )

  return (
    <CustomHeaderNavigation className={styles.datePickerHeader} config={customheaderConfig}>
      <MonthPicker
        minDate={minDate}
        maxDate={maxDate}
        onChange={handleChange}
        displayDate={monthDate}
      />
    </CustomHeaderNavigation>
  )
}

export default DatePickerHeader
